export default "__VITE_ASSET__Bpd125e6__"